import {limitTo, rupiah, rupiahWithNegative} from 'utils/formatter'
import styles from './ItemTable.css'
import {maxBy, sumBy, indexOf} from 'lodash'

const PROMO_TYPE = {
  free_item: 'FREE',
  cash: 'CASH',
  percentage: 'PERCENTAGE'
}

const PROMO_ITEM_STATUS = {
  requirement: 'REQUIREMENT',
  reward: 'REWARD',
  both: 'BOTH',
  neither: 'NEITHER'
}

class ItemTable extends React.Component {
  _generatePromoCollection = (promo, item, isLastCheckout, totalPromoPercentage) => {
    let promoValueText = null
    let promoValue = null
    switch (promo.reward_discount_type) {
      case PROMO_TYPE['free_item']:
        promoValueText = ''
        promoValue = 0
        break
      case PROMO_TYPE['cash']:
        promoValueText = '(Rp)'
        promoValue = isLastCheckout ? promo.reward_amount > promo.gross ? Math.abs(promo.gross) : Math.abs(promo.reward_amount * promo.count) : null
        break
      case PROMO_TYPE['percentage']:
        promoValueText = `(${promo.reward_amount}%)`
        promoValue = isLastCheckout ? totalPromoPercentage : null
        break
    }
    let promoName = `${promo.promo_name.length > 20 ? `${promo.promo_name.substr(0, 17)}...` : promo.promo_name} ${promoValueText}`
    const promoType = promo.reward_discount_type
    const promoItemStatus = item.promo_item_status
    const promoSinglePrice = Math.abs(item.total_rewarded / item.amount)
    const promoReward = promo.reward_amount

    if (item.promo_item_status === PROMO_ITEM_STATUS['reward']) {
      promoName = `Reward - ${promoName}`
    }

    return {
      promoValueText,
      promoValue,
      promoName,
      promoType,
      promoItemStatus,
      promoSinglePrice,
      promoReward
    }
  }

  _renderPromo = (promoCollection, checkout, fromRefund, promoLastItem) => {
    if (promoCollection && promoCollection[checkout.id]) {
      return <div>
        <div className={styles['promo-box']}>
          <div className={styles['promo']}>
            <div className={`${styles['text-left']} ${indexOf(promoLastItem, checkout.id) > -1 ? styles['width-100percentage'] : ''}`}>{promoCollection[checkout.id].promoName}</div>
            <div>
              <div className={styles['text-right']}>
                {
                  (promoCollection[checkout.id].promoValue === 0 || promoCollection[checkout.id].promoType === PROMO_TYPE['free_item']) && ''
                }
              </div>
            </div>
          </div>
        </div>
        {
          promoCollection[checkout.id].promoType !== PROMO_TYPE['free_item'] && indexOf(promoLastItem, checkout.id) > -1 &&
            <div className={styles['promo-box']}>
              <div className={styles['promo']}>
                <div className={styles['text-left']}>{`Reward - ${promoCollection[checkout.id].promoName}`}</div>
                <div>
                  <div className={styles['text-right']}>
                    {
                        promoCollection[checkout.id].promoValue && promoCollection[checkout.id].promoType !== PROMO_TYPE['free_item']
                          ? rupiahWithNegative(fromRefund ? Math.abs(promoCollection[checkout.id].promoValue) : promoCollection[checkout.id].promoValue * -1)
                          : ''
                      }
                  </div>
                </div>
              </div>
            </div>
        }
      </div>
    }
  }

  render () {
    let {checkouts, checkoutPriceFormatter, promos, fromRefund} = this.props
    // Collect all of the promo based on the checkout id
    let promoItemCollection
    let promoLastItem = []
    if (promos) {
      promoItemCollection = {}
      promos.map(promo => {
        let maxItem = maxBy(promo.items, 'checkout_id')
        let totalPromoPercentage = sumBy(promo.items, 'total_rewarded')
        if (promo.reward_discount_type !== PROMO_TYPE['free_item']) {
          promoLastItem.push(maxItem['checkout_id'])
        }
        promo.items.map(item => {
          if (promo.reward_discount_type !== PROMO_TYPE['free_item']) {
            promoItemCollection[item.checkout_id] = this._generatePromoCollection(promo, item, maxItem['checkout_id'] === item.checkout_id, totalPromoPercentage)
          } else {
            promoItemCollection[item.checkout_id] = this._generatePromoCollection(promo, item, false, totalPromoPercentage)
          }
        })
      })
    }

    return (<table className={`table table-responsive no-border ${styles['checkout-table']}`}>
      <tbody>
        {checkouts.map((checkout) => (<tr key={checkout.id}>
          <td className={styles['checkout-cell']}>
            <div className={styles['item-main']}>
              <div className={styles['text-left']}>{ limitTo(checkout.item_name, 25)} { checkout.item_name.length > 25 ? '...' : '' }</div>
              <div className={styles['text-center']}>
              x{ Math.abs(checkout.quantity)}
              </div>

              <div className={styles['text-right']}>
                {
                  promoItemCollection && promoItemCollection[checkout.id] &&
                    (promoItemCollection[checkout.id].promoItemStatus === PROMO_ITEM_STATUS['reward'] ||
                      promoItemCollection[checkout.id].promoItemStatus === PROMO_ITEM_STATUS['neither'])
                    ? promoItemCollection[checkout.id].promoValue === 0 ? 'Free' : checkoutPriceFormatter(promoItemCollection[checkout.id].promoValue)
                    : checkoutPriceFormatter(checkout.price)
                }
              </div>
            </div>

            {checkout.item_variant_name && <div className={styles['item-variant-box']}>
              <div className={styles['text-left']}>
                {limitTo(checkout.item_variant_name, 45) } { checkout.item_variant_name.length > 45 ? '...' : '' }
              </div>
            </div>}

            {checkout.modifiers.length > 0 && <div className={styles['item-modifier-box']}>
              {checkout.modifiers.map((modifier, i) => (<div className={styles['item-modifier']} key={i}>
                <div className={styles['text-left']}>
                  {limitTo(modifier.modifier_name, 15)} {modifier.modifier_name.length > 15 ? '...' : ''} - &nbsp;
                {limitTo(modifier.modifier_option_name, 15)} {modifier.modifier_option_name.length > 15 ? '...' : ''} - &nbsp;
                {rupiah(modifier.price)}
                </div>
                <div className={styles['text-right']} />
              </div>))}
            </div>}

            {(!promoItemCollection || (promoItemCollection && !promoItemCollection[checkout.id]) ||
              (promoItemCollection && promoItemCollection[checkout.id] && promoItemCollection[checkout.id].promoItemStatus !== PROMO_ITEM_STATUS['reward'])) &&
            checkout.discounts.length > 0 && <div className={styles['discount-box']}>
              {checkout.discounts.map((discount, i) => (<div className={styles['discount']} key={i}>
                <div className={styles['text-left']}>
                  {limitTo(discount.discount_name, 25)} {discount.discount_name.length > 25 ? '...' : ''}
                ({discount.discount_percentage}%)
              </div>
                <div className={styles['text-right']}>{rupiahWithNegative(discount.discount_amount * -1)}</div>
              </div>))}
            </div>}

            {checkout.note && <div className={styles['item-note']}>
              <div className={styles['text-left']}>
                <span>
                  <div>{checkout.note}</div>
                </span>
              </div>
            </div>}

            {this._renderPromo(promoItemCollection, checkout, fromRefund, promoLastItem)}
          </td>
        </tr>))}
      </tbody>
    </table>)
  }
}

ItemTable.propTypes = {
  checkouts: React.PropTypes.array,
  checkoutPriceFormatter: React.PropTypes.func
}

export default ItemTable



// WEBPACK FOOTER //
// ./app/components/receipt/commons/ListItemBox/ItemTable.js